import React, { useState } from 'react'
import { Content, Flex, Pane, Text } from '@leverege/ui-elements'

import { GlobalState } from '@leverege/ui-redux'
import { push } from '@leverege/molten-core/lib/routes/History'
import GanttChart from './GanttChart'
import OccupancyGraph from './occupancyGraph/OccupancyGraph'
import OccupancyGraphToggleButton from './occupancyGraph/OccupancyGraphToggleButton'

import S from './CycleAndWorkforceTracking.css'

export default function CycleAndWorkforceTracking( props ) {

  const [ lwButtonActive, setLwButtonActive ] = useState( false )
  const [ uwButtonActive, setUwButtonActive ] = useState( false )
  const [ allLinesActive, setAllLinesActive ] = useState( true )
  
  const navigateToMoldHalfPage = ( { locationId, lineId } ) => {
    const { location : { pathname } } = props
    const url = `${pathname}/${lineId}/`
    GlobalState.dispatch( push( url ) )
  }

  return (
    <Flex className={S.container} variant="colM">
      <Pane variant="dashboardCard">
        <Content relative>
          <Content.Header variant="dashboardCardHeaderBottomBorder|dashboardCardHeader">
            <Text variant="detailTitle">Cycle Activity</Text>
          </Content.Header>
          <Content.Area variant="dashboardCardArea">
            <GanttChart {...props} onClickLabel={navigateToMoldHalfPage} />
          </Content.Area>
        </Content>
      </Pane>
      <Pane variant="dashboardCard">
        <Content relative>
          <Content.Header
            layout="flex:rowSpaceBetweenCenter"
            variant="dashboardCardHeaderBottomBorder|dashboardCardHeader">
            <Text variant="detailTitle">Worker Count</Text>
            <OccupancyGraphToggleButton 
              lwButtonActive={lwButtonActive}
              setLwButtonActive={setLwButtonActive}
              uwButtonActive={uwButtonActive}
              setUwButtonActive={setUwButtonActive}
              allLinesActive={allLinesActive}
              setAllLinesActive={setAllLinesActive}/>
          </Content.Header>
          <Content.Area variant="dashboardCardArea">
            <OccupancyGraph {...props} 
              lwButtonActive={lwButtonActive}
              uwButtonActive={uwButtonActive}
              allLinesActive={allLinesActive} />
          </Content.Area>
        </Content>
      </Pane>
    </Flex>
  )
}
